import type { AutofillItem } from "./types";

export const criteria: AutofillItem[] = [
  {
    keyword: "プロジェクト",
    contents: [
      "新たな挑戦が含まれるプロジェクトを好みます。",
      "プロジェクトが私にとってエキサイティングであるかで判断します。",
      "社会的責任に配慮されたプロジェクトであることを重視します。",
    ],
  },
  {
    keyword: "ロール",
    contents: [
      "自分の強みを活かせるロールであるかで判断します。",
      "私にとって、新たな挑戦が含まれるロールについて、積極的に検討します。",
      "固定的ではなく、柔軟なアプローチができるロールを好みます。",
      "高品質な成果物を提供するため、得意分野に絞ります。",
    ],
  },
  {
    keyword: "メンバー",
    contents: [
      "プロフェッショナルな姿勢を持ったメンバーと共に取り組めることを重視します。",
      "長期的な関係構築を重視しています。",
      "コミュニケーションが迅速に円滑に行えることを重視します。",
    ],
  },
  {
    keyword: "クレジット",
    contents: [
      "名前（クレジット）が表に発表できる作品のみお請けしています。",
      "クレジットを公表できる案件のみ、お引き受けします。",
      "公開媒体（ウェブサイト、ソーシャルメディア）において、クレジットがどのように提示されるかは重視します。",
    ],
  },
  {
    keyword: "条件",
    contents: [
      "納期に無理がなく、品質を保てる案件を重視します。",
      "対価が明確で、支払期日が保証されている案件のみお引き受けします。",
      "著作権譲渡のプロジェクトは、お引き受けできません。",
      "成果に応じたインセンティブがある案件を重視します。",
      "オンライン完結ではなく、オフラインでのコミュニケーションを重視します。",
      "対価が明確で、支払期日が保証されているプロジェクトのみお引き受けします。",
    ],
  },
];
